import React from "react";
import { SiteRoutes } from "./router/Routes";
import { OracleRoutes } from "./router/oracle";
import { LoadingCoverScreen } from "./components/LoadingCoverScreen/LoadingCoverScreen";
import { ErrorModal } from "./components/ErrorModal/ErrorModal";
import { useSelector } from "react-redux";
import "./App.css";
import {
  pageLoadingSelector,
  showErrorModalSelector,
} from "./reducers/app/selector";

function App() {
  const pageLoading = useSelector(pageLoadingSelector);
  const showErrorModal = useSelector(showErrorModalSelector);
  return (
    <div>
      {pageLoading && <LoadingCoverScreen />}
      {showErrorModal && <ErrorModal />}
      {/* <SiteRoutes /> */}
      <OracleRoutes />
    </div>
  );
}

export default App;
